import React, { Component } from 'react'
import { connect } from 'react-redux'

import Button from 'components/button/button'
import Icon from 'components/icon/icon'

import Slider from 'react-slick'

import { 
    openModal,
    extendTrial
} from 'state/actions'

import {
    getCurrentAccount
} from 'state/selectors'

import { 
    getPriceAndSymbol,
    isMobile
} from 'utils'

class ModalPlans extends Component {
    businessPlan = null

    getPrice = _ => {
        const {
            planAndCurrencyData
        } = this.props

        const {
            symbol,
            price
        } = getPriceAndSymbol(null, false, planAndCurrencyData)

        return symbol+price
    }

    confirm = _ => {
        const {
            openModal,
            closeCallback,
            accountData,
            extendTrial
        } = this.props
        
        closeCallback()

        setTimeout(_ => {
            if(!accountData.has_had_trial_already){
                // fresh upgrade
                openModal('upgrade','account')
            }else if(!accountData.has_had_second_trial_already){
                extendTrial(accountData)

                // "can I have another week?"
                openModal('welcome','business', {
                    isExtension: true
                })
            }else{
                // had trial and extension
                openModal('upgrade','account')
            }
        },100)
    }

    getCopy = _ => {
        const {
            data
        } = this.props

        let title = "It's Business time."
        let body = 'Enjoy <em>unlimited projects</em>, an extra <em>25GB</em> of storage and a whole lot of extra features.'

        if(data && data.feature){
            switch(data.feature){
                case 'teams':
                    title = 'Create <em>teams</em> in Business.'
                    body = `Group your staff, and choose who can see what. Start your 14-day free trial today.`
                    break
                case 'projects':
                    title = `Want <em>unlimited projects</em>?`
                    body = `Free accounts are limited to 10 active projects. Archive an old one, or try Business <em>free for 30 days</em>.`
                    break
                case 'files':
                    title = `You've hit your limit.`
                    body = `Free accounts are limited to 5GB of storage. Get an <em>extra 25GB</em> on Business. It's free for 30 days. `
                    break
                case 'gantts':
                    title = `Use <em>Gantt Charts</em> in Business.`
                    body = `See an overview of what's happening when. In Hassl, and in Excel.`
                    break
                case 'columns':
                    title = `<em>Customize projects</em> in Business`
                    body = `Add, edit and rearrange columns. Start your 30-day free trial today.`
                    break
            }
        }

        return {
            title,
            body
        }
    }

    seeFeatures = _ => {
        this.slider.slickGoTo(1)
    }
    
	render() {
        const {
            hideFeatureList,
            planAndCurrencyData,
            accountData
        } = this.props

        if(!planAndCurrencyData){
            return null
        }

        const {
            planData
        } = planAndCurrencyData

        this.businessPlan = planData.find(plan => {
            return plan.plan_id == 2
        })

        const {
            title,
            body
        } = this.getCopy()

        const _isMobile = isMobile()

		const sliderProps = _isMobile ? {
			adaptiveHeight: true,
			arrows: false,
			dots: true,
			initialSlide: 0
		} : {}

        const Element = _isMobile ? Slider : React.Fragment

        let ctaLabels = {
            desktop: 'Try it free!',
            mobile: 'Start 30-day free trial'
        }

        if(accountData.has_had_trial_already){
            if(accountData.has_had_second_trial_already){
                ctaLabels = {
                    desktop: 'Upgrade now',
                    mobile: 'Upgrade now'
                }
            }else{
                ctaLabels = {
                    desktop: 'Try it again?',
                    mobile: 'Commence 30-day trial again'
                }
            }
        }

		return(
			<div className="modal-pricing">
                { !_isMobile ?
                    <img className="decoration" src={document.base + "/images/decoration/plans.png"} />
                : null}
                <Element {...sliderProps} ref={ref => this.slider = ref}>
                    <div className="left">
                        <h2 dangerouslySetInnerHTML={{ __html: title }} />
                        <p dangerouslySetInnerHTML={{ __html: body }} />
                        <Button 
                            size={'big'} 
                            level={'high'} 
                            callback={this.confirm} 
                            label={ctaLabels.desktop} 
                        />
                        { _isMobile ? 
                            <Button 
                                size={'big'} 
                                level={'low'} 
                                callback={this.seeFeatures} 
                                label={'See features ›'} 
                            />
                        : null }
                        <span className="subtitle">
                            { this.getPrice() }/user after trial. No credit card required.
                        </span>
                    </div>
                    <div className="right">
                        { _isMobile ?
                            <React.Fragment>
                                <h2>
                                    What's on Business?
                                </h2>
                                <p>
                                    Everything you need. No clutter, no crap.
                                </p>
                            </React.Fragment>
                        : null }
                        <ul>
                            { !hideFeatureList && this.businessPlan.features.map((feature, index) => {
                                return (
                                    <li key={index} className={feature.bold ? 'bold' : null}>
                                        <Icon name="check" />
                                        <span className={feature.hover_copy ? "tooltip-trigger" : null}>
                                            { feature.feature }
                                            { (feature.hover_copy && !_isMobile) ?
                                                <React.Fragment>
                                                    <Icon name="fe-info" />
                                                    <div className="tooltip">
                                                        { feature.hover_copy }
                                                    </div>
                                                </React.Fragment>
                                            : null }
                                        </span>
                                    </li>
                                )
                            }) }
                        </ul>
                        { _isMobile ?
                            <Button 
                                size={'big'} 
                                level={'high'} 
                                callback={this.confirm} 
                                label={ctaLabels.mobile} 
                            />
                        : null }
                    </div>
                </Element>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
        planAndCurrencyData: state.auth.planAndCurrencyData,
        accountData: getCurrentAccount(state)
	}
}

export default connect(mapStateToProps, { 
    openModal,
    extendTrial
})(ModalPlans)